import {createRef} from 'react'

const settingsFormRef = createRef()
const structureFormRef = createRef()
const domainFormRef = createRef()
const advancedFormRef = createRef()

export {
    settingsFormRef,
    structureFormRef,
    domainFormRef,
    advancedFormRef
}
